import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IConsultDuplicatedTransactionsFormMeta {
  cardHoldernumber: FormInputMeta,
  merchant: FormInputMeta,
  transactionCode: FormInputMeta,
  merchantCategoryCode: FormInputMeta,
  transactionAmount: FormInputMeta,
  transactionCurrency: FormInputMeta,
  date: FormInputMeta,
  authorizationNumber: FormInputMeta,

  // Schema
  schema: any,
}

const ConsultDuplicatedTransactionsFormMeta = {} as IConsultDuplicatedTransactionsFormMeta;

ConsultDuplicatedTransactionsFormMeta.cardHoldernumber = {
  name: 'cardHoldernumber',
  type: 'checkbox',
  label: 'Numero porteur',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.merchant = {
  name: 'merchant',
  type: 'checkbox',
  label: 'Commerçant',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.merchantCategoryCode = {
  name: 'merchantCategoryCode',
  type: 'checkbox',
  label: 'Code catégorie commerçant',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.transactionCode = {
  name: 'transactionCode',
  type: 'checkbox',
  label: 'Code transaction',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.transactionAmount = {
  name: 'transactionAmount',
  type: 'checkbox',
  label: 'Montant transaction',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.transactionCurrency = {
  name: 'transactionCurrency',
  type: 'checkbox',
  label: 'Devise transaction',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.authorizationNumber = {
  name: 'authorizationNumber',
  type: 'checkbox',
  label: 'Numero autorisation',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};
ConsultDuplicatedTransactionsFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date',
  placeholder: "",
  validation: yup.string().required("Ce champ est requis")
};

ConsultDuplicatedTransactionsFormMeta.schema = yup.object().shape(getValidationSchema(ConsultDuplicatedTransactionsFormMeta));

export default ConsultDuplicatedTransactionsFormMeta;